import * as AttendanceFormTypes from "AttendanceForm/Utils/GraphQl/AttendanceFormData";
import { GET_ATTENDANCE_FORM_DATA } from "../../Utils/Queries/AttendanceFormValidateSession";
import { useLazyQuery } from "@apollo/client/react";
import { useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";
import { Box } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { LoadingIndicator } from "AttendanceForm/Components/LoadingIndicator/LoadingIndicator";
import { TrainerDetailsForm } from "../TrainerDetails/TrainerDetailsForm";
import { AttendanceFormError } from "../Errors/AttendanceFormError";

export const AttendanceForm = (): React.ReactElement => {
  const { eventId } = useParams<{ eventId?: string }>();
  const styles = useStyles();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const eventIdHash = searchParams.get("sig");
  const [getAttendanceFormData, { loading: attendanceFormLoading, data: attendance }] =
    useLazyQuery<AttendanceFormTypes.AttendanceForm>(GET_ATTENDANCE_FORM_DATA, {
      fetchPolicy: "no-cache"
    });

  useEffect(() => {
    getAttendanceFormData({
      variables: {
        eventId: eventId,
        eventIdHash: eventIdHash,
      }
    });
  }, [eventId, eventIdHash, getAttendanceFormData]);

  return (
    <>
      {attendanceFormLoading || attendance == undefined ? (
        <Box display="flex" justifyContent="center" className={styles.loader}>
          <LoadingIndicator size="3rem" color="primary" />
        </Box>
      ) : (
        <Box>
          {attendance?.attendanceFormData?.validationErrors?.length > 0 ? (
            <AttendanceFormError
              validationErrors={attendance.attendanceFormData.validationErrors}
            ></AttendanceFormError>
          ) : (
            <TrainerDetailsForm eventId={eventId} eventHash={eventIdHash} />
          )}
        </Box>
      )}
    </>
  );
};

const useStyles = makeStyles(() => ({
  loader: {
    marginTop: "40vh",
  },
}));
